import { render, staticRenderFns } from "./find-pwd.vue?vue&type=template&id=3bc8b5b1&"
import script from "./find-pwd.vue?vue&type=script&lang=js&"
export * from "./find-pwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports